<template>
  <div class="app-container content">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
        <el-select v-model="course_id" clearable placeholder="Seleccionar curso" filterable @change="handleSearch()">
          <el-option
            v-for="course in courses"
            :key="course.id"
            :label="course.name"
            :value="course.id"
          />
        </el-select>
      </el-col>
      <template v-if="is_admin">
        <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
          <el-select v-model="teacher_id" clearable placeholder="Seleccionar profesor" filterable @change="handleSearch()">
            <el-option
              v-for="teacher in teachers"
              :key="teacher.id"
              :label="teacher.fullname"
              :value="teacher.id"
            />
          </el-select>
        </el-col>
      </template>
      <el-col :span="6">
        <el-date-picker
          v-model="week"
          type="week"
          format="[Semana] WW"
          placeholder="Semana"
          :picker-options="{ firstDayOfWeek: 1 }"
          :clearable="false"
          @change="handleSearch()"
        />
      </el-col>
    </el-row>
    <hr>
    <div v-loading="loading">
      <full-calendar ref="fullCalendar" :options="calendarOptions" />
    </div>
  </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import esLocale from '@fullcalendar/core/locales/es';
import interactionPlugin from '@fullcalendar/interaction';
export default {
  props: ['is_admin', 'date_week'],
  components: {
    FullCalendar,
  },
  data() {
    return {
      calendarOptions: {
        eventClick: (info) => {
          this.showListStudents(info.event.id, info.event.start);
        },
        customButtons: {
          buttonLeft: {
            icon: 'fc-icon fc-icon-chevron-left',
            click: () => {
              const calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.prev();
              this.week = calendarApi.getDate();
              this.fetchTimetables(this.week);
            },
          },
          buttonRight: {
            icon: 'fc-icon fc-icon-chevron-right',
            click: () => {
              const calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.next();
              this.week = calendarApi.getDate();
              this.fetchTimetables(this.week);
            },
          },
          dateNow: {
            text: 'Hoy',
            click: () => {
              const calendarApi = this.$refs.fullCalendar.getApi();
              this.calendarOptions.events = [];
              calendarApi.today();
              this.week = calendarApi.getDate();
              this.fetchTimetables(this.week);
            },
          },
        },
        showNonCurrentDates: false,
        initialView: 'timeGridWeek',
        views: {
          timeGridWeek: {
            type: 'timeGrid',
          },
        },
        weekends: true,
        hiddenDays: [ 0 ],
        fixedWeekCount: false,
        headerToolbar: {
          left: 'buttonLeft,buttonRight dateNow',
          center: 'title',
          right: 'timeGridWeek',
        },
        slotLabelFormat: [
          {
            hour12: false,
            hour: 'numeric',
            minute: '2-digit',
            omitZeroMinute: false,
            meridiem: 'short',
          }
        ],
        slotDuration: '00:15:00',
        slotMinTime: '07:00:00',
        locale: esLocale,
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        timeZone: 'UTC',
        events: [],
        firstDay: 1,
      },
      actualDate: new Date(),
      timetables: [],
      courses: [],
      course_id: '',
      teacher_id: '',
      week: this.date_week,
      teachers: [],
      loading: false,
    };
  },
  created() {
    this.loading = true;
    this.fetchTimetables(0);
    this.fetchCourses();
    this.fetchTeachers();
  },
  methods: {
    handleSearch() {
      let date = this.$refs.fullCalendar.getApi().getDate();
      this.fetchTimetables(date);
    },
    fetchTimetables(date) {
      this.calendarOptions.events = [];
      // this.week !== '' ? this.$refs.fullCalendar.getApi().gotoDate(this.week) : '';
      // this.setCalendarDate(date);
      axios.get('/timetables-json', {
        params: {
          calendar_date: date,
          course_id: this.course_id,
          teacher_id: this.teacher_id,
          week: this.week,
        }
      })
      .then(res => {
        this.week !== '' ? this.$refs.fullCalendar.getApi().gotoDate(this.week) : '';
        this.timetables = res.data;
        this.setEvents();
        this.loading = false;
      })
      .catch(e => {
        console.log(e.response);
      })
      this.setEvents();
    },
    fetchCourses() {
      axios.get('/courses-json')
      .then(res => {
        this.courses = res.data;
      })
      .catch(e => {
        console.log(e.response);
      })
    },
    fetchTeachers() {
      axios.get('/teachers-json')
      .then(res => {
        this.teachers = res.data;
      })
      .catch(e => {
        console.log(e.response);
      })
    },
    setCalendarDate(date) {
      if (date !== 0 && date.getMonth() === this.actualDate.getMonth()) {
        this.$refs.fullCalendar.getApi().gotoDate(this.actualDate);
      }
    },
    setEvents() {
      const events = [];
      this.timetables.forEach((timetable) => {
        events.push({
          'id': timetable.id,
          'title': timetable.capacity + ' - ' +timetable.name + " - " + timetable.teacher_name,
          'date': timetable.date_start,
          'borderColor': timetable.color,
          'backgroundColor': timetable.color,
          'textColor': timetable.text_color,
          'start': timetable.start,
          'end': timetable.end,
          'display': 'block',
        });
      });
      this.calendarOptions.events = events;
    },
    showListStudents(timetable_id, date) {
      this.$emit('timetableData', [timetable_id, date, this.week]);
    }
  },
};
</script>
